import { Box } from "@mui/material";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import { trimActiveStatusDropdowns } from "../TrimsMaster/data";

export const catalogActiveStatusColumn = {
	name: "Active Status",
	key: "active_status",
	data_type: datatypes.STRING.key,
	input_type: inputTypes.SELECT.key,
	[selectOptionsKeyName]: {
		type: arrType,
		list: Object.values(trimActiveStatusDropdowns),
	},
	constraints: { NOTNULL: true, DISPLAY: true },
	default_value: trimActiveStatusDropdowns.INACTIVE.key,
};

export const statusBadgeCell = (value, activeValue = trimActiveStatusDropdowns.ACTIVE.key) => (
	<Box width="100%" display="flex" justifyContent="center">
		<Box
			sx={{
				py: 0.5,
				px: 1,
				borderRadius: 1,
				fontWeight: 700,
				fontSize: 14,
				textAlign: "center",
				color: value === activeValue ? "#2e7d32" : "#b71c1c",
				bgcolor: value === activeValue ? "#e8f5e9" : "#ffebee",
				width: "fit-content",
			}}>
			{value || "-"}
		</Box>
	</Box>
);

export const withCatalogStatusColumn = (columns = []) =>
	columns.map((column) =>
		column.key === catalogActiveStatusColumn.key
			? {
					...column,
					renderCell: ({ row }) => statusBadgeCell(row?.[catalogActiveStatusColumn.key]),
				}
			: column,
	);
